export const deduplicateByProperty = <T>(arr: T[], objKey: keyof T): T[] =>
    arr.reduce<T[]>((acc: T[], curr: T) => (acc.some((a: T) => a[objKey] === curr[objKey]) ? acc : [...acc, curr]), []);
